import { observer } from 'mobx-react';
import styled from 'styled-components';

// Components
import ModifierGroupView from 'components/cart-item-editor/ModifierGroupView';

// Constants
import breakpoints from 'constants/breakpoints';

// Hooks
import { useStores } from 'hooks/use-stores';
import { type MenuItemModifierGroup } from 'api/types';
import { useItemSheet } from 'hooks/use-item-sheet';

function ModifierGroups() {
  const { displayedItem } = useItemSheet();
  const { menuDataStore } = useStores();
  const { menuItem } = displayedItem;

  const sortModGroups = (modGroupAId: MenuItemModifierGroup, modGroupBId: MenuItemModifierGroup) => {
    if (!modGroupAId || !modGroupBId) {
      return 0;
    }
    const modGroupA = menuDataStore.modifierGroupsById[modGroupAId.modifierGroupId];
    const modGroupB = menuDataStore.modifierGroupsById[modGroupBId.modifierGroupId];
    return modGroupB.min_selected - modGroupA.min_selected;
  };

  return (
    <Container data-testid="modifier-groups-modal" hasParent={!!displayedItem.parent}>
      {menuItem.modifierGroups?.sort(sortModGroups).map((modGroup) => (
        <ModifierGroupView key={modGroup.modifierGroupId} modGroup={modGroup} />
      ))}
    </Container>
  );
}

export default observer(ModifierGroups);

const Container = styled.div<{ hasParent: boolean }>`
  flex: 1;
  padding-bottom: ${({ hasParent }) => (hasParent ? '1.5rem' : '0')};

  @media (min-width: ${breakpoints.md}px) {
    padding: 0 0 0 1.5rem;
  }
`;
